import { tr } from "@/lib/i18n";

export const STATUS_COLORS = {
    "Submitted": "#00B4D8",
    "In Review": "#FFB703",
    "On Hold": "#EF476F",
    "Pending": "#94A3B8",
    "Approved": "#06D6A0",
    "Rejected": "#0A2540",
};

export default function StatusBadge({ status, size = "sm" }) {
    const color = STATUS_COLORS[status] || "#94A3B8";
    return (
        <span
            data-testid={`status-badge-${status.toLowerCase().replace(/\s+/g, "-")}`}
            className={`inline-flex items-center gap-1.5 font-semibold rounded-full whitespace-nowrap ${
                size === "md" ? "text-xs px-3 py-1" : "text-[11px] px-2.5 py-0.5"
            }`}
            style={{ backgroundColor: `${color}1A`, color }}
        >
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: color }} />
            {tr(status)}
        </span>
    );
}
